function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import resizeWrapper from './resizeWrapper';
import Loader from '../loader';
import entityComposition from '../classes/entityComposition';
const Upload = ({
  accept: _accept = {
    'image/jpeg': []
  },
  children: _children = null,
  disabled: _disabled = false,
  errorText: _errorText = 'Only .JPG images are allowed',
  helpText: _helpText = null,
  loading,
  onUpload,
  notificationActions
}) => {
  const message = `Failed to upload${_errorText ? `:\n${_errorText}` : ' file'}`;
  const rejection = () => notificationActions.error({
    message
  });
  if (loading) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: '100px'
      }
    }, /*#__PURE__*/React.createElement(Loader, null));
  }
  let renderedChildren = _helpText || 'Click or drop an image file here to upload. Note: only .JPG images are allowed.';
  if (_children) {
    renderedChildren =
    /*#__PURE__*/
    // prevent propagation to stop react-dropzonefrom capturing click, opening file picker
    React.createElement("div", {
      onClick: evt => {
        // pre react-dropzone 10, preventDefault was required, not stopPropagation
        // evt.preventDefault();
        evt.stopPropagation();
      },
      role: "presentation"
    }, _children);
  }
  return /*#__PURE__*/React.createElement(Dropzone, {
    onDrop: _disabled ? () => {} : onUpload,
    noClick: _disabled,
    onDropRejected: rejection,
    accept: _accept,
    multiple: true // handle multiple files in parent 'onUpload' method to show warning message
    ,
    activeStyle: {
      backgroundColor: 'rgba(0,0,0,0.15)'
    }
  }, ({
    getInputProps,
    getRootProps
  }) => /*#__PURE__*/React.createElement("div", _objectSpread(_objectSpread({}, getRootProps()), {}, {
    className: "dropzone t-u-dropzone"
  }), /*#__PURE__*/React.createElement("input", _objectSpread({
    alt: "file-input"
  }, getInputProps())), renderedChildren));
};
Upload.propTypes = {
  accept: PropTypes.shape({}),
  children: PropTypes.node,
  disabled: PropTypes.bool,
  errorText: PropTypes.string,
  helpText: PropTypes.string,
  loading: PropTypes.bool.isRequired,
  onUpload: PropTypes.func.isRequired,
  notificationActions: PropTypes.shape({
    error: PropTypes.func
  }).isRequired
};
export const ResizedUploader = entityComposition(resizeWrapper(Upload), [], {}, ['notification']);
export { Upload as TestUpload };
export default entityComposition(Upload, [], {}, ['notification']);